import { uniqBy } from 'lodash'

const validator = {
  data() {
    var checkErpOrder = (rule, value, callback) => {
      if (this.erpModeSwitch !== 1) {
        return callback()
      }
      if (this.scheduleForm.trafficType === 2 && this.payTraffic) {
        return callback(new Error('已填写排期总量'))
      }
      callback()
    }
    var checkIsCorrect = (rule, value, callback) => {
      if (parseInt(value) === 1) {
        callback(new Error('投放量和投放日期可能不对应，请检查'))
      } else if (parseInt(value) === 2) {
        callback(new Error('已投放日期计划量小于已曝光量，请检查'))
      } else if (parseInt(value) === 3) {
        callback(new Error('请检查投放总量和每日排期量+每日赠送量+每日补量是否一致'))
      } else if (parseInt(value) === 4) {
        callback(new Error('每日投放量必须为整数'))
      } else if (parseInt(value) === 5) {
        callback(new Error('关联ERP订单才可设置排期量'))
      } else if (parseInt(value) === 6) {
        callback(new Error('关联销售子订单才可设置排期量'))
      } else {
        callback()
      }
    }
    var checkTotalTraffic = (rule, value, callback) => {
      if (this.scheduleForm.trafficType === 1) {
        callback()
      } else {
        if (!value) {
          callback(new Error('请输入投放总量'))
        } else {
          const reg = /^[1-9]+[0-9]*$/
          if (!reg.test(value)) {
            callback(new Error('只能输入正整数'))
          } else {
            if (this.scheduleForm.trafficUnit === 0) {
              if (parseInt(value) > 2000000) {
                callback(new Error('投放总量不能超过，2,000,000CPM'))
              } else {
                callback()
              }
            } else {
              if (parseInt(value) > 2000000000) {
                callback(new Error('投放总量不能超过，2,000,000,000PV'))
              } else {
                callback()
              }
            }
          }
        }
      }
    }
    var checkPayTraffic = (rule, value, callback) => {
      if (value && !/^([1-9]+[0-9]*)|0$/.test(value)) {
        return callback(new Error('只能输入正整数'))
      }
      if (this.erpModeSwitch === 1 && !this.scheduleForm.erpSubOrder && this.scheduleForm.scheduleStatus === 1 && value) {
        return callback(new Error('关联ERP订单才可设置排期量'))
      }
      if (!value && !this.scheduleForm.freeTraffic && !this.scheduleForm.addedTraffic) {
        return callback(new Error('排期总量+赠送总量+补量总量必须等于投放总量'))
      }
      if (this.scheduleForm.totalTraffic) {
        const totalCount = parseInt(this.scheduleForm.totalTraffic)
        const freeCount = this.scheduleForm.freeTraffic ? parseInt(this.scheduleForm.freeTraffic) : 0
        const addedCount = this.scheduleForm.addedTraffic ? parseInt(this.scheduleForm.addedTraffic) : 0
        const payCount = value ? parseInt(value) : 0
        if (totalCount !== (freeCount + payCount + addedCount)) {
          return callback(new Error('排期总量+赠送总量+补量总量必须等于投放总量'))
        }
        callback()
      }
      callback()
    }
    var checkFreeTraffic = (rule, value, callback) => {
      if (value && !/^([1-9]+[0-9]*)|0$/.test(value)) {
        return callback(new Error('只能输入正整数'))
      }
      if (!value && !this.scheduleForm.payTraffic && !this.scheduleForm.addedTraffic) {
        return callback(new Error('排期总量+赠送总量+补量总量必须等于投放总量'))
      }
      if (this.scheduleForm.totalTraffic) {
        const totalCount = parseInt(this.scheduleForm.totalTraffic)
        const payCount = this.scheduleForm.payTraffic ? parseInt(this.scheduleForm.payTraffic) : 0
        const addedCount = this.scheduleForm.addedTraffic ? parseInt(this.scheduleForm.addedTraffic) : 0
        const freeCount = value ? parseInt(value) : 0
        if (totalCount !== (freeCount + payCount + addedCount)) {
          return callback(new Error('排期总量+赠送总量+补量总量必须等于投放总量'))
        }
        callback()
      }
      callback()
    }
    var checkAddedTraffic = (rule, value, callback) => {
      if (value && !/^([1-9]+[0-9]*)|0$/.test(value)) {
        return callback(new Error('只能输入正整数'))
      }
      if (!value && !this.scheduleForm.payTraffic && !this.scheduleForm.freeTraffic) {
        return callback(new Error('排期总量+赠送总量+补量总量必须等于投放总量'))
      }
      if (this.scheduleForm.totalTraffic) {
        const totalCount = parseInt(this.scheduleForm.totalTraffic)
        const payCount = this.scheduleForm.payTraffic ? parseInt(this.scheduleForm.payTraffic) : 0
        const freeCount = this.scheduleForm.freeTraffic ? parseInt(this.scheduleForm.freeTraffic) : 0
        const addedCount = value ? parseInt(value) : 0
        if (totalCount !== (freeCount + payCount + addedCount)) {
          return callback(new Error('排期总量+赠送总量+补量总量必须等于投放总量'))
        }
        callback()
      }
      callback()
    }
    var validateMinSize = (rule, value, callback) => {
      if (value) {
        const regx = /^[1-9]\d*$/
        if (!regx.test(value)) {
          callback(new Error('最小尺寸必须为大于0的整数'))
        } else {
          if (Number(value) < 200 && Number(value) > 0) {
            if (!this.isOwn && Number(value) < 50) {
              return callback(new Error('最小尺寸不能低于50'))
            }
            if (this.scheduleForm.maxSize) {
              if (Number(value) >= Number(this.scheduleForm.maxSize)) {
                callback(new Error('最小尺寸必须小于最大尺寸'))
              } else {
                callback()
              }
            } else {
              callback()
            }
          } else if (Number(value) >= 200) {
            callback(new Error('最小尺寸必须小于200'))
          } else {
            callback()
          }
        }
      } else {
        callback(new Error('自定义条件下，最小尺寸必填'))
      }
    }
    var validateMaxSize = (rule, value, callback) => {
      if (value) {
        const regx = /^[1-9]\d*$/
        if (!regx.test(value)) {
          callback(new Error('最大尺寸必须为大于0的整数'))
        } else {
          if (Number(value) <= 200 && Number(value) > 0) {
            if (this.scheduleForm.minSize) {
              if (Number(value) <= Number(this.scheduleForm.minSize)) {
                callback(new Error('最大尺寸必须大于最小尺寸'))
              } else {
                callback()
              }
            }
          } else if (Number(value) > 200) {
            callback(new Error('最大尺寸不能超过200'))
          } else {
            callback()
          }
        }
      } else {
        callback(new Error('自定义条件下，最大尺寸必填'))
      }
    }
    var validateBrandList = (rule, value, callback) => {
      // 需要选择品牌
      if (this.showOtherDirections) {
        if (this.isOwn && this.directinal.isNeedBrands) {
          if (value.length === 0) {
            callback(new Error('未设置品牌机型定向'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    var checkScheduleName = (rule, value, callback) => {
      if (value) {
        if (value.length > 45) {
          callback(new Error('计划名称最多不能超过45个字'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请填写计划单名称'))
      }
    }
    var handleCheckUnion = () => {
      if (this.scheduleForm.unionSequence !== 0 && this.selectTable.data.length === 0) {
        return 'none'
      }
      if (this.selectTable.data.every(item => item.unionSeq === 1)) {
        return 'allOne'
      }
      // 关联频控的顺序校验：所有的顺序没有重复
      const uniqSeqData = uniqBy(this.selectTable.data, 'unionSeq')
      if (uniqSeqData.length !== this.selectTable.data.length) {
        return 'repeat'
      }
      return 'successSeq'
    }
    var validateFreqCheck = (rule, value, callback) => {
      const checkStatus = handleCheckUnion()
      if (checkStatus === 'none') {
        callback(new Error('请选择关联频控'))
      } else if (this.scheduleForm.unionSequence === 2 && checkStatus !== 'allOne') {
        callback(new Error('无序的关联频控，顺序必须为1'))
      } else if (
        this.scheduleForm.unionSequence === 1 &&
        this.selectTable.data.length > 1 &&
        (checkStatus === 'repeat' || checkStatus === 'allOne')
      ) {
        callback(new Error('有序的关联频控，顺序不能一致'))
      } else {
        callback()
      }
    }
    var checkScheduleSource = (rule, value, callback) => {
      if (this.planType !== 1) {
        return callback()
      }
      if (!value || value === 0) {
        callback(new Error('请选择程序化来源'))
      } else {
        callback()
      }
    }
    var validateSubTraffic = (rule, value, callback) => {
      if (value) {
        if (!this.scheduleForm.trafficDaily || parseInt(value) > parseInt(this.scheduleForm.trafficDaily || 0)) {
          callback(new Error('双周期频控次数要小于等于频次控制次数'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请填写双周期频控次数'))
      }
    }
    var validateReceivePct = (rule, value, callback) => {
      if (this.receivePctType === 0) {
        return callback()
      }
      if (value === '' || value === undefined) {
        return callback(new Error('请输入溢出比'))
      }
      if (!Number.isInteger(value * 1) || value * 1 <= 0) {
        return callback(new Error('请输入正整数'))
      }
      if (value > 100000) {
        return callback(new Error('溢出比不能超过100000,请重新输入'))
      }
      callback()
    }
    var validAssessmentPct = (rule, value, callback) => {
      if (this.exposurePctType === 0) {
        return callback()
      }
      if (value === '' || value === undefined) {
        return callback(new Error(`请输入${this.exposurePctType === 2 ? '考核' : ''}溢出比`))
      }
      if (!Number.isInteger(value * 1) || value * 1 <= 0) {
        return callback(new Error('请输入正整数'))
      }
      if (this.exposurePctType === 1 && value * 1 > 100) {
        return callback(new Error('溢出比不能超过100%'))
      }
      callback()
    }
    var validExtraPct = (rule, value, callback) => {
      if (this.exposurePctType !== 2) {
        return callback()
      }
      if (value === '' || value === undefined) {
        return callback(new Error('请输入额外溢出比'))
      }
      if (!Number.isInteger(value * 1) || value * 1 < 0) {
        return callback(new Error('请输入大于等于0的整数'))
      }
      callback()
    }
    var validExposurePct = (rule, value, callback) => {
      if (this.exposurePctType !== 2 || !this.scheduleForm.checkExposurePct) {
        return callback()
      }
      if (value > 100) {
        return callback(new Error('溢出比总和不能超过100%'))
      }
      callback()
    }
    var validateCtr = (rule, value, callback) => {
      if (this.ctrType === 0) {
        return callback()
      }
      if (value === '') {
        return callback(new Error('请输入CTR权重'))
      }
      if (!Number.isInteger(value * 1) || value * 1 <= 0 || value * 1 > 1000) {
        return callback(new Error('请输入1~1000的整数'))
      }
      callback()
    }
    var checkDmpTags = (rule, value, callback) => {
      if (this.scheduleForm.policyName && value && value.length === 0) {
        return callback(new Error('请选择人群'))
      }
      callback()
    }
    var validateTrafficDaily = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        return callback(new Error('请填写频次'))
      }
      if (this.scheduleForm.unionSequence === 1 && this.selectTable.data.length) {
        const hasDiffSequence = this.selectTable.data.some(item => {
          return item.trafficDaily !== parseInt(value)
        })
        if (hasDiffSequence) {
          return callback(new Error('有顺序的关联频控，计划单频次必须一致'))
        }
      }
      callback()
    }
    var validateDealId = (rule, value, callback) => {
      if (this.dealIdType === 1 && !value) {
        return callback(new Error('请填写dealID'))
      }
      if (this.dealIdType === 1 && !/^[a-zA-Z0-9]+$/.test(value)) {
        return callback(new Error('请输入字母数字'))
      }
      callback()
    }

    var validatePackageName = (rule, value, callback) => {
      if (this.scheduleForm.directPackageSave === 0) {
        return callback()
      }
      if (!value) {
        return callback(new Error('请输入定向包名称'))
      }
      this.$service.checkDirectPackageName({ directPackageName: value }).then(res => {
        if (res === 1) {
          callback(new Error('定向包名称已存在，请重新输入'))
        } else {
          callback()
        }
      })
    }

    return {
      rules: {
        erpOrderName: [{ validator: checkErpOrder, trigger: 'change' }],
        isCorrect: [{ required: true, validator: checkIsCorrect, trigger: 'change' }],
        isFreeCorrect: [{ required: true, validator: checkIsCorrect, trigger: 'change' }],
        isAddedCorrect: [{ required: true, validator: checkIsCorrect, trigger: 'change' }],
        spaceId: [{ required: true, message: '请选择广告位', trigger: 'change' }],
        scheduleName: [{ required: true, validator: checkScheduleName, trigger: ['blur', 'change'] }],
        payTraffic: [{ validator: checkPayTraffic, trigger: 'blur' }],
        freeTraffic: [{ validator: checkFreeTraffic, trigger: 'blur' }],
        addedTraffic: [{ validator: checkAddedTraffic, trigger: 'blur' }],
        scheduleSource: [{ validator: checkScheduleSource, trigger: 'change' }],
        totalTraffic: [{ required: true, validator: checkTotalTraffic, trigger: 'blur' }],
        trafficDaily: [{ validator: validateTrafficDaily, trigger: 'blur' }],
        subTrafficDaily: [{ required: true, validator: validateSubTraffic, trigger: 'blur' }],
        minSize: [{ validator: validateMinSize, trigger: 'blur' }],
        maxSize: [{ validator: validateMaxSize, trigger: 'blur' }],
        brandList: [{ type: 'array', validator: validateBrandList, trigger: 'change' }],
        unionFreq: [{ required: true, message: '此项必填', trigger: 'blur' }],
        subUnionFreq: [{ required: true, message: '此项必填', trigger: 'blur' }],
        unionFreqCheck: [{ validator: validateFreqCheck, trigger: 'blur' }],
        receivePct: [{ validator: validateReceivePct, trigger: 'blur' }],
        checkExposurePct: [{ validator: validAssessmentPct, trigger: 'blur' }],
        addExposurePct: [{ validator: validExtraPct, trigger: 'blur' }],
        exposurePct: [{ validator: validExposurePct, trigger: 'blur' }],
        ctr: [{ validator: validateCtr, trigger: 'blur' }],
        dmpTags: [{ validator: checkDmpTags, trigger: 'blur' }],
        dealId: [{ validator: validateDealId, trigger: 'change' }],
        recId: [{ required: true, message: '此项必填', trigger: 'blur' }],
        directPackageName: [{ validator: validatePackageName, trigger: 'blur' }]
      }
    }
  }
}

export default validator
